/**
 * Resolves protocol-relative service hosts and same-origin proxy paths.
 * Absolute URLs stay unchanged; browser paths need an origin before Request construction.
 */
export function resolveAbsoluteUrl(url: string): string {
	// A configured /api/v1 proxy must resolve against the page, not be passed to new URL without a base.
	if (
		url.startsWith("/") &&
		!url.startsWith("//") &&
		typeof window !== "undefined"
	) {
		return new URL(url, window.location.origin).href
	}
	if (!url.startsWith("//")) {
		return url
	}

	if (typeof window !== "undefined") {
		return `${window.location.protocol}${url}`
	}

	return `https:${url}`
}
